<style>
.input__wrapper input {
  width: 95%;
}
.input__wrapper input label {
  margin-right: 5px;
}
.input__wrapper {
  padding: 5px;
}
#editDictionaryModal .v--modal-box.v--modal {
  min-height: 250px !important;
  min-width: 450px !important;
}
#editDictionaryModal .v-text-field__slot input {
  font-size: 12px;
}
#description {
  padding-top: 10px;
  font-size: 12px;
}
#newSchemaInput,
#newTableInput {
  margin-left: 5px;
}
.btn--editDict {
  position: absolute;
  bottom: 10px;
  right: 20px;
}
</style>

<template>
  <Modal
    modalName="editDictionaryModal"
    title="EDYCJA SŁOWNIKA"
    :buttons="['']"
    @opened="fillCurrentDict"
  >
    <v-layout wrap align-center>
      <v-flex xs12>
        <p id="description">W celu edycji słownika wprowadź nowe wartości oddzielone przecinkiem.</p>
      </v-flex>
      <v-flex xs6>
        <div class="input__wrapper">
          <v-text-field v-model="dictName" id="newNameInput" placeholder="Nazwa" height="16"></v-text-field>
        </div>
      </v-flex>
      <v-flex xs6>
        <div class="input__wrapper">
          <v-text-field v-model="dictValues" id="newValuesInput" placeholder="Wartości" height="16"></v-text-field>
        </div>
      </v-flex>
    </v-layout>
    <span
      class="group pa-2 btn--editDict"
      title="Wykonaj edycję słownika ogólnego"
      @click="editDictionary"
    >
      <v-icon>check_circle</v-icon>
    </span>
  </Modal>
</template>

<script>
import Modal from "../../../../shared/Modal";

export default {
  components: {
    Modal
  },
  data: () => ({
    dictName: "",
    dictValues: "",
    dictId: undefined
  }),
  methods: {
    editDictionary() {
      let newDictList = [];
      for (let i of this.dictValues.toString().split(",")) {
        newDictList.push(i.trim());
      }

      let payload = {
        newId: this.dictId,
        content: {
          description: this.dictName,
          values: newDictList
        }
      };
      this.$store.dispatch("editDict", payload).then(success => {
        if (success) {
          this.$modal.hide("editDictionaryModal");
          this.$root.$emit(
            "showSnackbar",
            "success",
            "Pomyślnie zakończono edycję słownika"
          );
          this.$emit("updateDicts");
        } else {
          this.$root.$emit(
            "showSnackbar",
            "red",
            "Podczas edycji słownika wystąpił błąd"
          );
        }
      });
    },
    fillCurrentDict() {
      this.dictName = this.$store.getters.getCurrentEditedDict["description"];
      this.dictValues = this.$store.getters.getCurrentEditedDict["values"];
      this.dictId = this.$store.getters.getCurrentEditedDict["id"];
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/viewer/settings/modals/dictionaries/EditDictionary.vue